/**
 * http network error
 */
export default class HttpNetworkError extends Error {
  public errorCode: string = null
  public body: any = null
  public isHttpNetworkError = true
  public name = 'HttpNetworkError'
  public config: any = null

  constructor(error: Error, errorCode: string, config: any = null) {
    super(error.message)
    this.errorCode = errorCode
    this.config = config
  }


}
